export const getUserAvatar = (user) => {
    const { brand, homeOrganization } = user;
    return brand?.cdnLogoUrl || homeOrganization?.cdnLogoUrl;
};
